export const NAME_REGEX = /^[A-Za-z]{2,40}$/;
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
export const KEY_NAME_REGEX = /^[a-zA-Z0-9\s-]*$/;

export const WORKFLOW_MODES = {
  BAG_ONLY: "bag",
  BAGS_AND_LABELS: "baglabel",
  BAG_ONLY_WITH_AUTH: "BagsOnlyAuth"
};

export const SCOPE_MODES = {
  CITY: "city",
  GLOBAL: "global"
};

export const KIOSKLOG_EVENTS = {
  LOGIN: "Login",
  CUSTOMER_LOOKUP: "CustomerLookup",
  CUSTOMER_QR: "CustomerQR",
  BAGTAG_SUBMISSION: "BagtagSubmission"
};

export const ERRORLOG_STATUS = {
  NOCHANGES: "No Changes",
  INCOMPLETE: "Incomplete",
  ADDED: "Added",
  ERROR: "Error",
  EDITED: "Edited",
  SYNCED: "Synced",
  ALLSYNC_CONNECTIONERROR: "AllSyncConnectionError",
  SINGLESYNC_CONNECTIONERROR: "SingleSyncConnectionError",
  ALLSYNC_INCOMPLETE: "AllSyncIncomplete",
  SINGLESYNC_ERROR: "SingleSyncError",
  COMPLETED: "completed"
};
